import { Injectable, inject } from '@angular/core';
import { WIRELESS_ROUTE } from '../app.constant';
import { BreadcrumbsService } from '../core/breadcrumbs/breadcrumbs.service';
import { manageSimBreadcrumbsConfigs } from './manage-sim-breadcrumbs.config';
import { ContactDetailFacadeService } from '../state/contact-detail/contact-detail-facade.service';
import { of } from 'rxjs';

export const IPHONE_ESIM_SUPPORT_PAGE_LINK = 'https://www.fido.ca/support/mobility/activate-esim-on-a-device#apple';
export const PIXEL_ESIM_SUPPORT_PAGE_LINK =
  'https://www.fido.ca/support/mobility/activate-esim-on-a-device#google-pixel';
export const SAMSUNG_ESIM_SUPPORT_PAGE_LINK = 'https://www.fido.ca/support/mobility/activate-esim-on-a-device#samsung';
export const SIM_DEVICE_SUPPORT_PAGE_LINK = 'https://www.fido.ca/support/mobility/device-support';

@Injectable()
export class ManageSimAppConfigService {
  private readonly breadcrumbsService = inject(BreadcrumbsService);
  private readonly contactDetailFacadeService = inject(ContactDetailFacadeService);

  constructor() {
    this.breadcrumbsService.addBreadcrumbsData(manageSimBreadcrumbsConfigs);
    this.contactDetailFacadeService.loadContactDetailForSelectedAccount$().subscribe();
  }

  get contactEmail$() {
    // return empty email address to disable the email functionality for sim-swap OTP as described in DC-36303.
    return of('');
  }

  get unableToGetContactEmail$() {
    // intentional to disable the email functionality for sim-swap OTP as described in DC-36303.
    return of(true);
  }

  readonly tileHeaderClassName = 'text-title-3';

  get digitalSimAccordionPanels() {
    return [
      {
        panelName: 'iphone',
        panelItems: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        panelName: 'samsung',
        panelItems: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        panelName: 'pixel',
        panelItems: ['step1', 'step2', 'step3', 'step4'],
      },
    ];
  }

  readonly baseSimNumber = '89302';

  get fallbackRoute() {
    return `/${WIRELESS_ROUTE}`;
  }

  get iphoneESimSupportPageLink() {
    return IPHONE_ESIM_SUPPORT_PAGE_LINK;
  }

  get pixelESimSupportPageLink() {
    return PIXEL_ESIM_SUPPORT_PAGE_LINK;
  }

  get samsungESimSupportPageLink() {
    return SAMSUNG_ESIM_SUPPORT_PAGE_LINK;
  }

  get simDeviceSupportPageLink() {
    return SIM_DEVICE_SUPPORT_PAGE_LINK;
  }

  get analyticsHierarchy() {
    return ['myaccount', 'manage-sim', 'change-sim'];
  }
}
